import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { TablaGeneral } from "./components/tablaGeneral";
import { GetAllUsers, GetUsersPaginated } from "../../../hooks/getUsers";
import { useDispatch } from "react-redux";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";

export const UsuariosIndex = () => {
  const dispatch = useDispatch();
  const { getAllUsersMutation } = GetAllUsers();
  const [users, setUsers] = useState([]);

  const get_all_users = (paginationToken) => {
    return new Promise((resolve, reject) => {
      getAllUsersMutation(
        { limit: 60, paginationToken },
        {
          onSuccess: (data) => {
            setUsers((prev) => [...prev, ...data.users]);
            resolve(data.paginationToken ?? null);
          },
          onError: (error) => {
            console.log(error);
            reject(error);
          },
        },
      );
    });
  };

  useEffect(() => {
    dispatch(HEADER_DATA_UPDATE({ nombreData: null }));

    const fetchUsers = async () => {
      let pt = null;
      pt = await get_all_users();
      if(pt){
        while (pt) {
          pt = await get_all_users(pt);
        }
      }
    };

    fetchUsers();
  }, []);

  return (
    <>
      <Grid container spacing={0} sx={{ height: "87vh" }}>
        <Grid
          item
          xs={12}
          sx={{ padding: "10px 20px", height: "100%" }}
          className="center_item"
        >
          <TablaGeneral
            key={"table_general"}
            sample={users}
            isLoading={false}
          />
        </Grid>
      </Grid>
    </>
  );
};
